export default function(state = null, action) {
	switch (action.type) {
		case 'IMAGE_SELECTED':
			return action.payload;
	}
	return state;
}



// WEBPACK FOOTER //
// ./src/reducers/reducer_active_image.js